import {useFieldArray, useFormContext} from "react-hook-form";
import {VariantOptionListItem} from "../variant-option-list-item";
import {ProductVariantsFormFieldsProps, ProductVariantsFormValues} from "../types";
import {AddVariantOptionButton} from "../add-variant-option-button";
import {FormFieldError} from "../../../../../design-system/form-field";
import {Space} from "antd";
import {usePricingCurrencies} from "@/features/currencies";
import {ProductPricingFormFieldsType} from "../../pricing/types";

type VariantOptionListProps = {
  variantIndex: number;
  productCurrencies: ProductPricingFormFieldsType["currencies"];
  productSelectedPriceType: "paid" | "free";
  hydratedRef: ProductVariantsFormFieldsProps["hydratedRef"];
};

export function VariantOptionList({
  variantIndex,
  productCurrencies,
  productSelectedPriceType,
  hydratedRef,
}: VariantOptionListProps) {
  const {connectedBankStatus} = usePricingCurrencies();
  const isBankConnected = connectedBankStatus.isBankConnected;
  const {control, formState, clearErrors} = useFormContext<ProductVariantsFormValues>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: `variants.${variantIndex}.options`,
  });
  const optionError = formState.errors?.variants?.[variantIndex]?.options?.message;

  function handleAddVariantOption() {
    clearErrors(`variants.${variantIndex}.options`);
    append({
      variant_option_id: undefined,
      name: `Option ${fields.length + 1}`,
      priceType: isBankConnected ? "paid" : "free",
      currencies:
        productSelectedPriceType === "free"
          ? [
              {
                currency: "NGN",
                price: 100,
              },
            ]
          : productCurrencies.length > 0
          ? [
              {
                currency: productCurrencies[0].callPriceCurrency,
                price: 100,
              },
            ]
          : [
              {
                currency: "NGN",
                price: 100,
              },
            ],
    });
  }

  return (
    <div>
      <Space size={24} direction="vertical" style={{display: "flex"}}>
        <Space size={24} direction="vertical" style={{display: "flex"}}>
          {fields.map((f, index) => (
            <VariantOptionListItem
              key={f.id}
              optionIndex={index}
              variantIndex={variantIndex}
              removeVariantOptionItem={remove}
              productCurrencies={productCurrencies}
              productSelectedPriceType={productSelectedPriceType}
              hydratedRef={hydratedRef}
            />
          ))}
        </Space>
        <Space size={optionError ? 16 : 0} direction="vertical" style={{display: "flex"}}>
          {optionError && <FormFieldError errorMessage={optionError} />}
          <AddVariantOptionButton
            lengthOfFields={fields.length}
            handleAddVariantOption={handleAddVariantOption}
          />
        </Space>
      </Space>
    </div>
  );
}
